import en from './en';
import fr from './hm';
import la from './la';

export default {
  ...en,
  ...fr,
  ...la,
};
